export const shellTranslations: Record<string, any> = {
  "pt": {
    "modes": {
      "operate": "Operar",
      "analyze": "Analisar",
      "plan": "Planear"
    },
    "navigation": {
      "assistant": "Fala com o teu dinheiro",
      "analytics": "Analítica",
      "cashflow": "Fluxo de Caixa",
      "transactions": "Transações",
      "profit_pulse": "Pulse",
      "pulse_check": "Pulse Check",
      "budgets": "Orçamentos",
      "calendar": "Calendário",
      "clients": "Clientes",
      "projects": "Projetos",
      "vendors": "Fornecedores",
      "people": "Pessoas",
      "reports": "Relatórios",
      "categories": "Categorias",
      "team_members": "Membros da Equipa",
      "bank_connections": "Ligações Bancárias",
      "billing": "Faturação",
      "settings": "Definições",
      "profile": "Perfil",
      "notifications": "Notificações",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Pesquisar",
      "search_placeholder": "Pesquisar...",
      "profile": "Perfil",
      "notifications": "Notificações",
      "settings": "Definições",
      "logout": "Terminar Sessão",
      "language": "Idioma",
      "section_organizations": "Organizações",
      "section_my_account": "A minha conta",
      "section_organization": "Organização",
      "mark_all_read": "Marcar todas como lidas",
      "view_all_notifications": "Ver todas as notificações",
      "ask_money": "Perguntar ao dinheiro"
    },
    "sidebar": {
      "collapse": "Recolher menu",
      "expand": "Expandir menu"
    },
    "tenant_selector": {
      "create_new": "Criar nova organização"
    },
    "help": {
      "menu_title": "Ajuda & Recursos",
      "documentation": "Documentação",
      "video_tutorials": "Tutoriais em Vídeo",
      "send_feedback": "Enviar Feedback",
      "contact_support": "Contactar Suporte"
    },
    "feedback": {
      "title": "Enviar Feedback",
      "description": "Ajude-nos a melhorar o MoneyLights. Partilhe o seu feedback, reporte bugs ou sugira novas funcionalidades.",
      "type_label": "Tipo de Feedback",
      "type_feedback": "Feedback Geral",
      "type_bug": "Reportar Bug",
      "type_feature": "Pedido de Funcionalidade",
      "type_feedback_desc": "Partilhe os seus pensamentos sobre o MoneyLights",
      "type_bug_desc": "Reportar um problema ou erro",
      "type_feature_desc": "Sugerir uma nova funcionalidade",
      "subject_label": "Assunto",
      "subject_placeholder": "Descreva brevemente...",
      "message_label": "Mensagem",
      "message_placeholder": "Forneça o máximo de detalhes possível...",
      "message_bug_placeholder": "Por favor descreva o bug:\n\n1. O que esperava que acontecesse?\n2. O que realmente aconteceu?\n3. Passos para reproduzir o problema",
      "message_feature_placeholder": "Descreva a funcionalidade que gostaria de ver:\n\n1. Que problema resolverá?\n2. Como imagina que funcione?\n3. Quem beneficiará?",
      "email_label": "Email",
      "email_placeholder": "O seu email (opcional)",
      "email_help": "Para que possamos acompanhar o seu feedback",
      "priority_label": "Prioridade",
      "priority_low": "Baixa",
      "priority_medium": "Média",
      "priority_high": "Alta",
      "priority_critical": "Crítica",
      "cancel": "Cancelar",
      "submit": "Enviar Feedback",
      "submitting": "A enviar...",
      "success_title": "Feedback Enviado!",
      "success_description": "Obrigado pelo seu feedback. Analisaremos e entraremos em contacto se necessário.",
      "error_title": "Erro ao Enviar",
      "error_description": "Não foi possível enviar o seu feedback. Por favor tente novamente.",
      "button_label": "Feedback & Suporte",
      "button_short": "Feedback"
    },
    "trial": {
      "banner": {
        "cta": "Escolher um plano",
        "dismiss": "Ocultar banner de teste",
        "active": {
          "title": "Teste — {{days}} dias restantes (termina {{endDate}})",
          "description": "Acesso total a todas as funcionalidades."
        },
        "last_day": {
          "title": "O teste termina amanhã",
          "description": "Escolha um plano para continuar a usar o MoneyLights sem interrupção."
        },
        "expired": {
          "title": "O período de teste terminou",
          "description": "Escolha um plano para continuar a usar dados bancários reais e insights financeiros."
        }
      },
      "empty_state": {
        "title": "Dados pausados",
        "description": "O teu Trial terminou. Escolhe um plano para continuar a ver dados bancários reais nesta conta.",
        "cta": "Escolher um plano"
      }
    },
    "profit_pulse": {
      "safe_to_spend": "Seguro para Gastar",
      "safe_to_spend_subtitle": "Seguro para Gastar — um valor claro para decidires com calma",
      "pending_distribution": "Tens €{{amount}} para distribuir",
      "revenue_cleared": "Receita limpa ✅",
      "operations_negative": "Operações negativas (virtual): estás a gastar dinheiro que pertence a outros envelopes.",
      "revenue_not_zero": "Falta distribuir: a Receita ainda não está a 0€.",
      "baseline_balance_notice": "O valor inicial é baseado no saldo atual das contas de Receita.",
      "distribute": "Distribuir",
      "pulse_check_cta_title": "Faz o Pulse Check",
      "pulse_check_cta_hint": "Descobre os % para alocar a Receita",
      "allocation_current_short": "Atual",
      "allocation_target_short": "Objetivo",
      "activate_headline": "Mais clareza sobre o teu dinheiro, sem stress.",
      "activate_body": "O Pulse organiza cada entrada em envelopes simples e mostra um número Seguro para Gastar para as decisões do dia a dia.",
      "activate_bullet_1": "Cria envelopes base para operações, lucro e reservas.",
      "activate_bullet_2": "Mostra o Seguro para Gastar no topo do painel.",
      "activate_bullet_3": "Dá-te controlo antes de cada distribuição automática.",
      "activate_helper": "Começa com a configuração base recomendada.",
      "bucket_revenue": "Receita",
      "bucket_operations": "Despesas Operacionais",
      "bucket_profit_vault": "Lucro",
      "bucket_taxes": "Reserva de Impostos (IRC)",
      "bucket_owner_pay": "Remuneração do Sócio",
      "bucket_reserve": "IVA",
      "revenue_accounts_title": "Contas de Receita",
      "revenue_accounts_description": "Seleciona as contas onde entram receitas. Só estas entradas contam para distribuir.",
      "revenue_currency_notice": "Na v1, apenas contas em {{currency}} podem ser Receita.",
      "revenue_currency_tooltip": "Na v1, só contas em {{currency}} podem ser Receita.",
      "revenue_accounts_banner": "Ainda não tens nenhuma conta de Receita configurada. Escolhe pelo menos uma conta para começar a distribuir.",
      "revenue_accounts_edit": "Alterar contas",
      "revenue_accounts_close": "Fechar",
      "revenue_accounts_selected": "Receita ativa:",
      "default_account": "Conta sem nome",
      "revenue_accounts_empty": "Sem contas disponíveis.",
      "revenue_label": "Receita",
      "review_inflows": "Receita",
      "allocation_preview": "Plano de alocação",
      "commit_distribution": "Confirmar distribuição",
      "included": "Incluído",
      "excluded": "Excluído",
      "distributable_amount": "Valor a distribuir",
      "runway": "Runway (dias)",
      "load_error": "Nao foi possivel carregar o Pulse.",
      "load_error_title": "Não foi possível carregar o Pulse",
      "load_error_body": "Verifica a ligação e tenta novamente.",
      "retry": "Tentar novamente",
      "preview_error": "Nao foi possivel preparar a distribuicao.",
      "commit_error": "Nao foi possivel confirmar a distribuicao.",
      "allocation_mismatch": "O total das alocacoes nao coincide com o valor a distribuir.",
      "cancel": "Cancelar",
      "buckets": "Envelopes",
      "delta": "Delta",
      "enable": "Ativar Pulse",
      "enable_description": "Ativa o modo Pulse e cria os envelopes base.",
      "activate_reassurance": "Não move dinheiro real no banco. Podes desativar quando quiseres.",
      "loading": "A carregar...",
      "accounts_load_error": "Nao foi possivel carregar as contas para o Pulse.",
      "accounts_update_error": "Nao foi possivel atualizar a conta de receita.",
      "operations": "Despesas Operacionais",
      "internal_transfer": "Transferência interna",
      "refund": "Reembolso"
    }
  },
  "en": {
    "modes": {
      "operate": "Operate",
      "analyze": "Analyze",
      "plan": "Plan"
    },
    "navigation": {
      "assistant": "Talk to your money",
      "analytics": "Analytics",
      "cashflow": "Cash Flow",
      "transactions": "Transactions",
      "profit_pulse": "Pulse",
      "pulse_check": "Pulse Check",
      "budgets": "Budgets",
      "calendar": "Calendar",
      "clients": "Clients",
      "projects": "Projects",
      "vendors": "Vendors",
      "people": "People",
      "reports": "Reports",
      "categories": "Categories",
      "team_members": "Team Members",
      "bank_connections": "Bank Connections",
      "billing": "Billing",
      "settings": "Settings",
      "profile": "Profile",
      "notifications": "Notifications",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Search",
      "search_placeholder": "Search...",
      "profile": "Profile",
      "notifications": "Notifications",
      "settings": "Settings",
      "logout": "Logout",
      "language": "Language",
      "section_organizations": "Organizations",
      "section_my_account": "My Account",
      "section_organization": "Organization",
      "mark_all_read": "Mark all read",
      "view_all_notifications": "View all notifications",
      "ask_money": "Ask your money"
    },
    "sidebar": {
      "collapse": "Collapse menu",
      "expand": "Expand menu"
    },
    "tenant_selector": {
      "create_new": "Create new organization"
    },
    "help": {
      "menu_title": "Help & Resources",
      "documentation": "Documentation",
      "video_tutorials": "Video Tutorials",
      "send_feedback": "Send Feedback",
      "contact_support": "Contact Support"
    },
    "feedback": {
      "title": "Send Feedback",
      "description": "Help us improve MoneyLights. Share your feedback, report bugs, or suggest new features.",
      "type_label": "Feedback Type",
      "type_feedback": "General Feedback",
      "type_bug": "Report Bug",
      "type_feature": "Feature Request",
      "type_feedback_desc": "Share your thoughts about MoneyLights",
      "type_bug_desc": "Report a problem or error",
      "type_feature_desc": "Suggest a new feature",
      "subject_label": "Subject",
      "subject_placeholder": "Briefly describe...",
      "message_label": "Message",
      "message_placeholder": "Please provide as much detail as possible...",
      "message_bug_placeholder": "Please describe the bug:\n\n1. What did you expect to happen?\n2. What actually happened?\n3. Steps to reproduce the issue",
      "message_feature_placeholder": "Describe the feature you'd like to see:\n\n1. What problem will it solve?\n2. How do you imagine it working?\n3. Who will benefit from it?",
      "email_label": "Email",
      "email_placeholder": "Your email (optional)",
      "email_help": "So we can follow up on your feedback",
      "priority_label": "Priority",
      "priority_low": "Low",
      "priority_medium": "Medium",
      "priority_high": "High",
      "priority_critical": "Critical",
      "cancel": "Cancel",
      "submit": "Send Feedback",
      "submitting": "Submitting...",
      "success_title": "Feedback Sent!",
      "success_description": "Thank you for your feedback. We'll review it and get back to you if needed.",
      "error_title": "Error Sending",
      "error_description": "We couldn't send your feedback. Please try again.",
      "button_label": "Feedback & Support",
      "button_short": "Feedback"
    },
    "trial": {
      "banner": {
        "cta": "Choose a plan",
        "dismiss": "Hide trial banner",
        "active": {
          "title": "Trial — {{days}} days left (ends {{endDate}})",
          "description": "Full access to all features."
        },
        "last_day": {
          "title": "Trial ends tomorrow",
          "description": "Choose a plan to continue using MoneyLights without interruption."
        },
        "expired": {
          "title": "Trial ended",
          "description": "Choose a plan to continue using real bank data and financial insights."
        }
      },
      "empty_state": {
        "title": "Data paused",
        "description": "Your Trial has ended. Choose a plan to continue viewing real bank data in this account.",
        "cta": "Choose a plan"
      }
    },
    "profit_pulse": {
      "safe_to_spend": "Safe-to-Spend",
      "safe_to_spend_subtitle": "Safe-to-Spend — a clear number to decide with confidence",
      "pending_distribution": "You have €{{amount}} to distribute",
      "revenue_cleared": "Revenue cleared ✅",
      "operations_negative": "Operations negative (virtual): you're spending money that belongs to other buckets.",
      "revenue_not_zero": "Pending distribution: Revenue is not yet €0.",
      "baseline_balance_notice": "The initial amount is based on the current balance of your Revenue accounts.",
      "distribute": "Distribute",
      "pulse_check_cta_title": "Do the Pulse Check",
      "pulse_check_cta_hint": "Discover the % to allocate Revenue",
      "allocation_current_short": "Current",
      "allocation_target_short": "Target",
      "activate_headline": "Clarity about your cash, without the stress.",
      "activate_body": "Pulse organizes each incoming payment into simple buckets and highlights a Safe-to-Spend number for daily decisions.",
      "activate_bullet_1": "Creates the core buckets for operations, profit, and reserves.",
      "activate_bullet_2": "Shows your Safe-to-Spend at the top of the dashboard.",
      "activate_bullet_3": "Lets you review incoming money before each distribution.",
      "activate_helper": "Start with the recommended base setup.",
      "bucket_revenue": "Revenue",
      "bucket_operations": "Operating Expenses",
      "bucket_profit_vault": "Profit",
      "bucket_taxes": "Tax Reserve",
      "bucket_owner_pay": "Owner's Pay",
      "bucket_reserve": "VAT",
      "revenue_accounts_title": "Revenue accounts",
      "revenue_accounts_description": "Select the accounts that receive revenue. Only these inflows count for distribution.",
      "revenue_currency_notice": "In v1, only {{currency}} accounts can be Revenue.",
      "revenue_currency_tooltip": "In v1, only {{currency}} accounts can be Revenue.",
      "revenue_accounts_banner": "No Revenue account is configured yet. Choose at least one to start distributing.",
      "revenue_accounts_edit": "Edit accounts",
      "revenue_accounts_close": "Close",
      "revenue_accounts_selected": "Active Revenue:",
      "default_account": "Unnamed account",
      "revenue_accounts_empty": "No accounts available.",
      "revenue_label": "Revenue",
      "review_inflows": "Revenue",
      "allocation_preview": "Allocation plan",
      "commit_distribution": "Commit distribution",
      "included": "Included",
      "excluded": "Excluded",
      "distributable_amount": "Distributable amount",
      "runway": "Runway (days)",
      "load_error": "We couldn't load Pulse.",
      "load_error_title": "Couldn't load Pulse",
      "load_error_body": "Check your connection and try again.",
      "retry": "Try again",
      "preview_error": "We couldn't prepare the distribution.",
      "commit_error": "We couldn't commit the distribution.",
      "allocation_mismatch": "The allocation total does not match the distributable amount.",
      "cancel": "Cancel",
      "buckets": "Buckets",
      "delta": "Delta",
      "enable": "Enable Pulse",
      "enable_description": "Enable Pulse and create the default buckets.",
      "activate_reassurance": "No real bank money moves. You can turn this off anytime.",
      "loading": "Loading...",
      "accounts_load_error": "We couldn't load the Pulse accounts.",
      "accounts_update_error": "We couldn't update the revenue account.",
      "operations": "Operating Expenses",
      "internal_transfer": "Internal transfer",
      "refund": "Refund"
    }
  },
  "es": {
    "modes": {
      "operate": "Operar",
      "analyze": "Analizar",
      "plan": "Planificar"
    },
    "navigation": {
      "assistant": "Habla con tu dinero",
      "analytics": "Analítica",
      "cashflow": "Flujo de Caja",
      "transactions": "Transacciones",
      "profit_pulse": "Pulse",
      "pulse_check": "Pulse Check",
      "budgets": "Presupuestos",
      "calendar": "Calendario",
      "clients": "Clientes",
      "projects": "Proyectos",
      "vendors": "Proveedores",
      "people": "Personas",
      "reports": "Informes",
      "categories": "Categorías",
      "team_members": "Miembros del Equipo",
      "bank_connections": "Conexiones Bancarias",
      "billing": "Facturación",
      "settings": "Configuración",
      "profile": "Perfil",
      "notifications": "Notificaciones",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Buscar",
      "search_placeholder": "Buscar...",
      "profile": "Perfil",
      "notifications": "Notificaciones",
      "settings": "Configuración",
      "logout": "Cerrar Sesión",
      "language": "Idioma",
      "section_organizations": "Organizaciones",
      "section_my_account": "Mi cuenta",
      "section_organization": "Organización",
      "mark_all_read": "Marcar todas como leídas",
      "view_all_notifications": "Ver todas las notificaciones",
      "ask_money": "Pregúntale a tu dinero"
    },
    "sidebar": {
      "collapse": "Contraer menú",
      "expand": "Expandir menú"
    },
    "tenant_selector": {
      "create_new": "Crear nueva organización"
    },
    "help": {
      "menu_title": "Ayuda y Recursos",
      "documentation": "Documentación",
      "video_tutorials": "Tutoriales en Vídeo",
      "send_feedback": "Enviar Comentarios",
      "contact_support": "Contactar Soporte"
    },
    "feedback": {
      "title": "Enviar Comentarios",
      "description": "Ayúdanos a mejorar MoneyLights. Comparte tus comentarios, reporta errores o sugiere nuevas funcionalidades.",
      "type_label": "Tipo de Comentario",
      "type_feedback": "Comentario General",
      "type_bug": "Reportar Error",
      "type_feature": "Solicitud de Funcionalidad",
      "type_feedback_desc": "Comparte tus opiniones sobre MoneyLights",
      "type_bug_desc": "Reportar un problema o error",
      "type_feature_desc": "Sugerir una nueva funcionalidad",
      "subject_label": "Asunto",
      "subject_placeholder": "Describe brevemente...",
      "message_label": "Mensaje",
      "message_placeholder": "Por favor, proporciona todos los detalles posibles...",
      "message_bug_placeholder": "Por favor describe el error:\n\n1. ¿Qué esperabas que pasara?\n2. ¿Qué pasó realmente?\n3. Pasos para reproducir el problema",
      "message_feature_placeholder": "Describe la funcionalidad que te gustaría ver:\n\n1. ¿Qué problema resolverá?\n2. ¿Cómo imaginas que funcione?\n3. ¿Quién se beneficiará?",
      "email_label": "Email",
      "email_placeholder": "Tu email (opcional)",
      "email_help": "Para que podamos hacer seguimiento a tus comentarios",
      "priority_label": "Prioridad",
      "priority_low": "Baja",
      "priority_medium": "Media",
      "priority_high": "Alta",
      "priority_critical": "Crítica",
      "cancel": "Cancelar",
      "submit": "Enviar Comentarios",
      "submitting": "Enviando...",
      "success_title": "¡Comentarios Enviados!",
      "success_description": "Gracias por tus comentarios. Los revisaremos y nos pondremos en contacto si es necesario.",
      "error_title": "Error al Enviar",
      "error_description": "No pudimos enviar tus comentarios. Por favor, inténtalo de nuevo.",
      "button_label": "Comentarios y Soporte",
      "button_short": "Comentarios"
    },
    "trial": {
      "banner": {
        "cta": "Elegir un plan",
        "dismiss": "Ocultar banner de prueba",
        "active": {
          "title": "Prueba — {{days}} días restantes (termina {{endDate}})",
          "description": "Acceso completo a todas las funcionalidades."
        },
        "last_day": {
          "title": "La prueba termina mañana",
          "description": "Elige un plan para continuar usando MoneyLights sin interrupción."
        },
        "expired": {
          "title": "Prueba terminada",
          "description": "Elige un plan para continuar usando datos bancarios reales e insights financieros."
        }
      },
      "empty_state": {
        "title": "Datos en pausa",
        "description": "Tu prueba ha terminado. Elige un plan para seguir viendo datos bancarios reales en esta cuenta.",
        "cta": "Elegir un plan"
      }
    },
    "profit_pulse": {
      "safe_to_spend": "Seguro para gastar",
      "safe_to_spend_subtitle": "Seguro para gastar — un valor claro para decidir con confianza",
      "pending_distribution": "Tienes €{{amount}} para distribuir",
      "revenue_cleared": "Ingresos limpios ✅",
      "operations_negative": "Operaciones negativas (virtual): estás gastando dinero que pertenece a otros sobres.",
      "revenue_not_zero": "Distribución pendiente: los ingresos aún no están en 0€.",
      "baseline_balance_notice": "El valor inicial se basa en el saldo actual de tus cuentas de Ingresos.",
      "distribute": "Distribuir",
      "activate_headline": "Más claridad sobre tu dinero, sin estrés.",
      "activate_body": "Pulse organiza cada ingreso en sobres simples y resalta un número Seguro para gastar para las decisiones diarias.",
      "activate_bullet_1": "Crea sobres base para operaciones, beneficio y reservas.",
      "activate_bullet_2": "Muestra el Seguro para gastar en la parte superior del panel.",
      "activate_bullet_3": "Te permite revisar los ingresos antes de cada distribución.",
      "activate_helper": "Empieza con la configuración base recomendada.",
      "bucket_revenue": "Ingresos",
      "bucket_operations": "Gastos Operativos",
      "bucket_profit_vault": "Beneficio",
      "bucket_taxes": "Reserva de Impuestos",
      "bucket_owner_pay": "Pago al Propietario",
      "bucket_reserve": "Reserva",
      "revenue_accounts_title": "Cuentas de ingresos",
      "revenue_accounts_description": "Selecciona las cuentas donde entran ingresos. Solo estas entradas cuentan para distribuir.",
      "revenue_currency_notice": "En v1, solo las cuentas en {{currency}} pueden ser ingresos.",
      "revenue_currency_tooltip": "En v1, solo las cuentas en {{currency}} pueden ser ingresos.",
      "revenue_accounts_banner": "Aún no hay ninguna cuenta de ingresos configurada. Elige al menos una para empezar a distribuir.",
      "revenue_accounts_edit": "Editar cuentas",
      "revenue_accounts_close": "Cerrar",
      "revenue_accounts_selected": "Ingresos activos:",
      "default_account": "Cuenta sin nombre",
      "revenue_accounts_empty": "No hay cuentas disponibles.",
      "revenue_label": "Ingresos",
      "review_inflows": "Ingresos",
      "allocation_preview": "Plan de asignación",
      "commit_distribution": "Confirmar distribución",
      "included": "Incluido",
      "excluded": "Excluido",
      "distributable_amount": "Importe a distribuir",
      "runway": "Autonomía (días)",
      "load_error": "No pudimos cargar Pulse.",
      "load_error_title": "No se pudo cargar Pulse",
      "load_error_body": "Comprueba tu conexión e inténtalo de nuevo.",
      "retry": "Reintentar",
      "preview_error": "No pudimos preparar la distribución.",
      "commit_error": "No pudimos confirmar la distribución.",
      "allocation_mismatch": "El total asignado no coincide con el importe a distribuir.",
      "cancel": "Cancelar",
      "buckets": "Sobres",
      "delta": "Delta",
      "enable": "Activar Pulse",
      "enable_description": "Activa Pulse y crea los sobres predeterminados.",
      "activate_reassurance": "No se mueve dinero real en el banco. Puedes desactivarlo cuando quieras.",
      "loading": "Cargando...",
      "accounts_load_error": "No pudimos cargar las cuentas de Pulse.",
      "accounts_update_error": "No pudimos actualizar la cuenta de ingresos.",
      "operations": "Gastos Operativos",
      "internal_transfer": "Transferencia interna",
      "refund": "Reembolso"
    }
  },
  "et": {
    "modes": {
      "operate": "Tegutseda",
      "analyze": "Anal\u00fc\u00fcsida",
      "plan": "Planeerida"
    },
    "navigation": {
      "assistant": "Räägi oma rahaga",
      "analytics": "Analüütika",
      "cashflow": "Rahavoog",
      "transactions": "Tehingud",
      "budgets": "Eelarved",
      "calendar": "Kalender",
      "clients": "Kliendid",
      "projects": "Projektid",
      "vendors": "Tarnijad",
      "people": "Inimesed",
      "reports": "Aruanded",
      "categories": "Kategooriad",
      "team_members": "Meeskonnaliikmed",
      "bank_connections": "Pangaühendused",
      "billing": "Arveldus",
      "settings": "Seaded",
      "profile": "Profiil",
      "notifications": "Teavitused",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Otsi",
      "search_placeholder": "Otsi...",
      "profile": "Profiil",
      "notifications": "Teavitused",
      "settings": "Seaded",
      "logout": "Logi välja",
      "language": "Keel",
      "section_organizations": "Organisatsioonid",
      "section_my_account": "Minu konto",
      "section_organization": "Organisatsioon",
      "mark_all_read": "Märgi kõik loetuks",
      "view_all_notifications": "Vaata kõiki teavitusi",
      "ask_money": "Küsi oma rahalt"
    },
    "sidebar": {
      "collapse": "Ahenda menüü",
      "expand": "Laienda menüü"
    },
    "tenant_selector": {
      "create_new": "Loo uus organisatsioon"
    },
    "help": {
      "menu_title": "Abi & Ressursid",
      "documentation": "Dokumentatsioon",
      "video_tutorials": "Video Õpetused",
      "send_feedback": "Saada Tagasisidet",
      "contact_support": "Võta Ühendust Toega"
    },
    "feedback": {
      "title": "Saada Tagasisidet",
      "description": "Aita meil MoneyLightsi parandada. Jaga oma tagasisidet, teata vigadest või soovita uusi funktsioone.",
      "type_label": "Tagasiside Tüüp",
      "type_feedback": "Üldine Tagasiside",
      "type_bug": "Teata Veast",
      "type_feature": "Funktsiooni Taotlus",
      "type_feedback_desc": "Jaga oma mõtteid MoneyLightsi kohta",
      "type_bug_desc": "Teata probleemist või veast",
      "type_feature_desc": "Soovita uut funktsiooni",
      "subject_label": "Teema",
      "subject_placeholder": "Kirjelda lühidalt...",
      "message_label": "Sõnum",
      "message_placeholder": "Palun anna võimalikult palju üksikasju...",
      "message_bug_placeholder": "Palun kirjelda viga:\n\n1. Mida sa ootasid, et juhtub?\n2. Mis tegelikult juhtus?\n3. Sammud probleemi taastootmiseks",
      "message_feature_placeholder": "Kirjelda funktsiooni, mida soovid näha:\n\n1. Millist probleemi see lahendab?\n2. Kuidas sa kujutled, et see töötab?\n3. Kes sellest kasu saab?",
      "email_label": "E-post",
      "email_placeholder": "Sinu e-post (valikuline)",
      "email_help": "Et saaksime sinu tagasisidele järgi tulla",
      "priority_label": "Prioriteet",
      "priority_low": "Madal",
      "priority_medium": "Keskmine",
      "priority_high": "Kõrge",
      "priority_critical": "Kriitiline",
      "cancel": "Tühista",
      "submit": "Saada Tagasiside",
      "submitting": "Saatmine...",
      "success_title": "Tagasiside Saadetud!",
      "success_description": "Täname tagasiside eest. Vaatame selle üle ja võtame vajaduse korral sinuga ühendust.",
      "error_title": "Saatmisviga",
      "error_description": "Me ei saanud sinu tagasisidet saata. Palun proovi uuesti.",
      "button_label": "Tagasiside & Tugi",
      "button_short": "Tagasiside"
    },
    "trial": {
      "banner": {
        "cta": "Vali plaan",
        "dismiss": "Peida prooviperioodi bänner",
        "active": {
          "title": "Proovperiood — {{days}} päeva jäänud (lõpeb {{endDate}})",
          "description": "Täielik ligipääs kõigile funktsioonidele."
        },
        "last_day": {
          "title": "Prooviperiood lõpeb homme",
          "description": "Vali plaan, et kasutada MoneyLightsi katkestusteta edasi."
        },
        "expired": {
          "title": "Prooviperiood on lõppenud",
          "description": "Vali plaan, et jätkata päris pangandusandmete ja finantsülevaadetega."
        }
      },
      "empty_state": {
        "title": "Andmed on peatatud",
        "description": "Sinu prooviperiood on lõppenud. Vali plaan, et jätkata selle konto päris pangandusandmete vaatamist.",
        "cta": "Vali plaan"
      }
    },
    "profit_pulse": {
      "bucket_revenue": "Tulu",
      "bucket_operations": "Tegevuskulud",
      "bucket_profit_vault": "Kasum",
      "bucket_taxes": "Maksureserv",
      "bucket_owner_pay": "Omaniku tasu",
      "bucket_reserve": "Reserv",
      "load_error_title": "Pulse'i laadimine ebaõnnestus",
      "load_error_body": "Kontrolli ühendust ja proovi uuesti.",
      "retry": "Proovi uuesti"
    }
  },
  "de": {
    "modes": {
      "operate": "Betreiben",
      "analyze": "Analysieren",
      "plan": "Planen"
    },
    "navigation": {
      "assistant": "Sprich mit deinem Geld",
      "analytics": "Analytik",
      "cashflow": "Cashflow",
      "transactions": "Transaktionen",
      "budgets": "Budgets",
      "calendar": "Kalender",
      "clients": "Kunden",
      "projects": "Projekte",
      "vendors": "Lieferanten",
      "people": "Personen",
      "reports": "Berichte",
      "categories": "Kategorien",
      "team_members": "Teammitglieder",
      "bank_connections": "Bankverbindungen",
      "billing": "Abrechnung",
      "settings": "Einstellungen",
      "profile": "Profil",
      "notifications": "Benachrichtigungen",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Suchen",
      "search_placeholder": "Suchen...",
      "profile": "Profil",
      "notifications": "Benachrichtigungen",
      "settings": "Einstellungen",
      "logout": "Abmelden",
      "language": "Sprache",
      "section_organizations": "Organisationen",
      "section_my_account": "Mein Konto",
      "section_organization": "Organisation",
      "mark_all_read": "Alle als gelesen markieren",
      "view_all_notifications": "Alle Benachrichtigungen anzeigen",
      "ask_money": "Frag dein Geld"
    },
    "sidebar": {
      "collapse": "Menü einklappen",
      "expand": "Menü ausklappen"
    },
    "tenant_selector": {
      "create_new": "Neue Organisation erstellen"
    },
    "help": {
      "menu_title": "Hilfe & Ressourcen",
      "documentation": "Dokumentation",
      "video_tutorials": "Video-Tutorials",
      "send_feedback": "Feedback Senden",
      "contact_support": "Support Kontaktieren"
    },
    "feedback": {
      "title": "Feedback Senden",
      "description": "Helfen Sie uns, MoneyLights zu verbessern. Teilen Sie Ihr Feedback, melden Sie Fehler oder schlagen Sie neue Funktionen vor.",
      "type_label": "Feedback-Typ",
      "type_feedback": "Allgemeines Feedback",
      "type_bug": "Fehler Melden",
      "type_feature": "Funktionswunsch",
      "type_feedback_desc": "Teilen Sie Ihre Gedanken über MoneyLights",
      "type_bug_desc": "Ein Problem oder einen Fehler melden",
      "type_feature_desc": "Eine neue Funktion vorschlagen",
      "subject_label": "Betreff",
      "subject_placeholder": "Kurz beschreiben...",
      "message_label": "Nachricht",
      "message_placeholder": "Bitte geben Sie so viele Details wie möglich an...",
      "message_bug_placeholder": "Bitte beschreiben Sie den Fehler:\n\n1. Was haben Sie erwartet, dass passiert?\n2. Was ist tatsächlich passiert?\n3. Schritte zur Reproduktion des Problems",
      "message_feature_placeholder": "Beschreiben Sie die Funktion, die Sie gerne sehen würden:\n\n1. Welches Problem wird es lösen?\n2. Wie stellen Sie sich vor, dass es funktioniert?\n3. Wer wird davon profitieren?",
      "email_label": "E-Mail",
      "email_placeholder": "Ihre E-Mail (optional)",
      "email_help": "Damit wir Ihr Feedback nachverfolgen können",
      "priority_label": "Priorität",
      "priority_low": "Niedrig",
      "priority_medium": "Mittel",
      "priority_high": "Hoch",
      "priority_critical": "Kritisch",
      "cancel": "Abbrechen",
      "submit": "Feedback Senden",
      "submitting": "Wird gesendet...",
      "success_title": "Feedback Gesendet!",
      "success_description": "Vielen Dank für Ihr Feedback. Wir werden es prüfen und uns bei Bedarf bei Ihnen melden.",
      "error_title": "Fehler beim Senden",
      "error_description": "Wir konnten Ihr Feedback nicht senden. Bitte versuchen Sie es erneut.",
      "button_label": "Feedback & Support",
      "button_short": "Feedback"
    },
    "trial": {
      "banner": {
        "cta": "Plan wählen",
        "dismiss": "Testphase-Banner ausblenden",
        "active": {
          "title": "Testphase — noch {{days}} Tage (endet {{endDate}})",
          "description": "Voller Zugriff auf alle Funktionen."
        },
        "last_day": {
          "title": "Die Testphase endet morgen",
          "description": "Wähle einen Plan, um MoneyLights ohne Unterbrechung weiter zu nutzen."
        },
        "expired": {
          "title": "Testphase beendet",
          "description": "Wähle einen Plan, um echte Bankdaten und finanzielle Insights weiter zu nutzen."
        }
      },
      "empty_state": {
        "title": "Daten pausiert",
        "description": "Deine Testphase ist beendet. Wähle einen Plan, um in diesem Konto weiterhin echte Bankdaten zu sehen.",
        "cta": "Plan wählen"
      }
    },
    "profit_pulse": {
      "bucket_revenue": "Einnahmen",
      "bucket_operations": "Betriebsausgaben",
      "bucket_profit_vault": "Gewinn",
      "bucket_taxes": "Steuerrücklage",
      "bucket_owner_pay": "Inhaberlohn",
      "bucket_reserve": "Rücklage",
      "load_error_title": "Pulse konnte nicht geladen werden",
      "load_error_body": "Überprüfe deine Verbindung und versuche es erneut.",
      "retry": "Erneut versuchen"
    }
  },
  "fr": {
    "modes": {
      "operate": "Op\u00e9rer",
      "analyze": "Analyser",
      "plan": "Planifier"
    },
    "navigation": {
      "assistant": "Parlez à votre argent",
      "analytics": "Analytique",
      "cashflow": "Flux de Trésorerie",
      "transactions": "Transactions",
      "budgets": "Budgets",
      "calendar": "Calendrier",
      "clients": "Clients",
      "projects": "Projets",
      "vendors": "Fournisseurs",
      "people": "Personnes",
      "reports": "Rapports",
      "categories": "Catégories",
      "team_members": "Membres de l'équipe",
      "bank_connections": "Connexions Bancaires",
      "billing": "Facturation",
      "settings": "Paramètres",
      "profile": "Profil",
      "notifications": "Notifications",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Rechercher",
      "search_placeholder": "Rechercher...",
      "profile": "Profil",
      "notifications": "Notifications",
      "settings": "Paramètres",
      "logout": "Déconnexion",
      "language": "Langue",
      "section_organizations": "Organisations",
      "section_my_account": "Mon compte",
      "section_organization": "Organisation",
      "mark_all_read": "Tout marquer comme lu",
      "view_all_notifications": "Voir toutes les notifications",
      "ask_money": "Demander à ton argent"
    },
    "sidebar": {
      "collapse": "Réduire le menu",
      "expand": "Développer le menu"
    },
    "tenant_selector": {
      "create_new": "Créer une nouvelle organisation"
    },
    "help": {
      "menu_title": "Aide & Ressources",
      "documentation": "Documentation",
      "video_tutorials": "Tutoriels Vidéo",
      "send_feedback": "Envoyer des Commentaires",
      "contact_support": "Contacter le Support"
    },
    "feedback": {
      "title": "Envoyer des Commentaires",
      "description": "Aidez-nous à améliorer MoneyLights. Partagez vos commentaires, signalez des bugs ou suggérez de nouvelles fonctionnalités.",
      "type_label": "Type de Commentaire",
      "type_feedback": "Commentaire Général",
      "type_bug": "Signaler un Bug",
      "type_feature": "Demande de Fonctionnalité",
      "type_feedback_desc": "Partagez vos réflexions sur MoneyLights",
      "type_bug_desc": "Signaler un problème ou une erreur",
      "type_feature_desc": "Suggérer une nouvelle fonctionnalité",
      "subject_label": "Sujet",
      "subject_placeholder": "Décrivez brièvement...",
      "message_label": "Message",
      "message_placeholder": "Veuillez fournir autant de détails que possible...",
      "message_bug_placeholder": "Veuillez décrire le bug :\n\n1. Que vous attendiez-vous à ce qui se passe ?\n2. Que s'est-il réellement passé ?\n3. Étapes pour reproduire le problème",
      "message_feature_placeholder": "Décrivez la fonctionnalité que vous aimeriez voir :\n\n1. Quel problème résoudra-t-elle ?\n2. Comment imaginez-vous qu'elle fonctionne ?\n3. Qui en bénéficiera ?",
      "email_label": "Email",
      "email_placeholder": "Votre email (facultatif)",
      "email_help": "Pour que nous puissions faire un suivi de vos commentaires",
      "priority_label": "Priorité",
      "priority_low": "Basse",
      "priority_medium": "Moyenne",
      "priority_high": "Élevée",
      "priority_critical": "Critique",
      "cancel": "Annuler",
      "submit": "Envoyer des Commentaires",
      "submitting": "Envoi en cours...",
      "success_title": "Commentaires Envoyés !",
      "success_description": "Merci pour vos commentaires. Nous les examinerons et vous contacterons si nécessaire.",
      "error_title": "Erreur d'Envoi",
      "error_description": "Nous n'avons pas pu envoyer vos commentaires. Veuillez réessayer.",
      "button_label": "Commentaires et Support",
      "button_short": "Commentaires"
    },
    "trial": {
      "banner": {
        "cta": "Choisir un forfait",
        "dismiss": "Masquer la bannière d'essai",
        "active": {
          "title": "Essai — {{days}} jours restants (fin {{endDate}})",
          "description": "Accès complet à toutes les fonctionnalités."
        },
        "last_day": {
          "title": "L’essai se termine demain",
          "description": "Choisissez un forfait pour continuer à utiliser MoneyLights sans interruption."
        },
        "expired": {
          "title": "Essai terminé",
          "description": "Choisissez un forfait pour continuer à utiliser des données bancaires réelles et des insights financiers."
        }
      },
      "empty_state": {
        "title": "Données en pause",
        "description": "Votre essai est terminé. Choisissez un forfait pour continuer à voir des données bancaires réelles dans ce compte.",
        "cta": "Choisir un forfait"
      }
    },
    "profit_pulse": {
      "bucket_revenue": "Revenus",
      "bucket_operations": "Frais d'exploitation",
      "bucket_profit_vault": "Profit",
      "bucket_taxes": "Réserve d'impôts",
      "bucket_owner_pay": "Rémunération du dirigeant",
      "bucket_reserve": "Réserve",
      "load_error_title": "Impossible de charger Pulse",
      "load_error_body": "Vérifie ta connexion et réessaie.",
      "retry": "Réessayer"
    }
  },
  "it": {
    "modes": {
      "operate": "Operare",
      "analyze": "Analizzare",
      "plan": "Pianificare"
    },
    "navigation": {
      "assistant": "Parla con i tuoi soldi",
      "analytics": "Analitica",
      "cashflow": "Flusso di Cassa",
      "transactions": "Transazioni",
      "budgets": "Budget",
      "calendar": "Calendario",
      "clients": "Clienti",
      "projects": "Progetti",
      "vendors": "Fornitori",
      "people": "Persone",
      "reports": "Rapporti",
      "categories": "Categorie",
      "team_members": "Membri del Team",
      "bank_connections": "Connessioni Bancarie",
      "billing": "Fatturazione",
      "settings": "Impostazioni",
      "profile": "Profilo",
      "notifications": "Notifiche",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Cerca",
      "search_placeholder": "Cerca...",
      "profile": "Profilo",
      "notifications": "Notifiche",
      "settings": "Impostazioni",
      "logout": "Esci",
      "language": "Lingua",
      "section_organizations": "Organizzazioni",
      "section_my_account": "Il mio account",
      "section_organization": "Organizzazione",
      "mark_all_read": "Segna tutte come lette",
      "view_all_notifications": "Vedi tutte le notifiche",
      "ask_money": "Chiedi ai tuoi soldi"
    },
    "sidebar": {
      "collapse": "Riduci menu",
      "expand": "Espandi menu"
    },
    "tenant_selector": {
      "create_new": "Crea nuova organizzazione"
    },
    "help": {
      "menu_title": "Aiuto & Risorse",
      "documentation": "Documentazione",
      "video_tutorials": "Tutorial Video",
      "send_feedback": "Invia Feedback",
      "contact_support": "Contatta il Supporto"
    },
    "feedback": {
      "title": "Invia Feedback",
      "description": "Aiutaci a migliorare MoneyLights. Condividi il tuo feedback, segnala bug o suggerisci nuove funzionalità.",
      "type_label": "Tipo di Feedback",
      "type_feedback": "Feedback Generale",
      "type_bug": "Segnala Bug",
      "type_feature": "Richiesta Funzionalità",
      "type_feedback_desc": "Condividi i tuoi pensieri su MoneyLights",
      "type_bug_desc": "Segnalare un problema o un errore",
      "type_feature_desc": "Suggerire una nuova funzionalità",
      "subject_label": "Oggetto",
      "subject_placeholder": "Descrivi brevemente...",
      "message_label": "Messaggio",
      "message_placeholder": "Fornisci quanti più dettagli possibili...",
      "message_bug_placeholder": "Si prega di descrivere il bug:\n\n1. Cosa ti aspettavi che accadesse?\n2. Cosa è successo realmente?\n3. Passaggi per riprodurre il problema",
      "message_feature_placeholder": "Descrivi la funzionalità che vorresti vedere:\n\n1. Quale problema risolverà?\n2. Come immagini che funzioni?\n3. Chi ne trarrà beneficio?",
      "email_label": "Email",
      "email_placeholder": "La tua email (opzionale)",
      "email_help": "In modo che possiamo dare seguito al tuo feedback",
      "priority_label": "Priorità",
      "priority_low": "Bassa",
      "priority_medium": "Media",
      "priority_high": "Alta",
      "priority_critical": "Critica",
      "cancel": "Annulla",
      "submit": "Invia Feedback",
      "submitting": "Invio in corso...",
      "success_title": "Feedback Inviato!",
      "success_description": "Grazie per il tuo feedback. Lo esamineremo e ti contatteremo se necessario.",
      "error_title": "Errore di Invio",
      "error_description": "Non siamo riusciti a inviare il tuo feedback. Riprova.",
      "button_label": "Feedback e Supporto",
      "button_short": "Feedback"
    },
    "trial": {
      "banner": {
        "cta": "Scegli un piano",
        "dismiss": "Nascondi banner di prova",
        "active": {
          "title": "Prova — {{days}} giorni rimanenti (scade {{endDate}})",
          "description": "Accesso completo a tutte le funzionalità."
        },
        "last_day": {
          "title": "La prova termina domani",
          "description": "Scegli un piano per continuare a usare MoneyLights senza interruzioni."
        },
        "expired": {
          "title": "Prova terminata",
          "description": "Scegli un piano per continuare a usare dati bancari reali e insight finanziari."
        }
      },
      "empty_state": {
        "title": "Dati in pausa",
        "description": "Il tuo periodo di prova è terminato. Scegli un piano per continuare a vedere dati bancari reali in questo account.",
        "cta": "Scegli un piano"
      }
    },
    "profit_pulse": {
      "bucket_revenue": "Ricavi",
      "bucket_operations": "Spese operative",
      "bucket_profit_vault": "Profitto",
      "bucket_taxes": "Riserva imposte",
      "bucket_owner_pay": "Compenso titolare",
      "bucket_reserve": "Riserva",
      "load_error_title": "Impossibile caricare Pulse",
      "load_error_body": "Controlla la connessione e riprova.",
      "retry": "Riprova"
    }
  },
  "nl": {
    "modes": {
      "operate": "Bedienen",
      "analyze": "Analyseren",
      "plan": "Plannen"
    },
    "navigation": {
      "assistant": "Praat met je geld",
      "analytics": "Analyse",
      "cashflow": "Cashflow",
      "transactions": "Transacties",
      "budgets": "Budgetten",
      "calendar": "Kalender",
      "clients": "Klanten",
      "projects": "Projecten",
      "vendors": "Leveranciers",
      "people": "Personen",
      "reports": "Rapporten",
      "categories": "Categorieën",
      "team_members": "Teamleden",
      "bank_connections": "Bankverbindingen",
      "billing": "Facturering",
      "settings": "Instellingen",
      "profile": "Profiel",
      "notifications": "Meldingen",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Zoeken",
      "search_placeholder": "Zoeken...",
      "profile": "Profiel",
      "notifications": "Meldingen",
      "settings": "Instellingen",
      "logout": "Uitloggen",
      "language": "Taal",
      "section_organizations": "Organisaties",
      "section_my_account": "Mijn account",
      "section_organization": "Organisatie",
      "mark_all_read": "Markeer alles als gelezen",
      "view_all_notifications": "Bekijk alle meldingen",
      "ask_money": "Vraag je geld"
    },
    "sidebar": {
      "collapse": "Menu inklappen",
      "expand": "Menu uitklappen"
    },
    "tenant_selector": {
      "create_new": "Nieuwe organisatie aanmaken"
    },
    "help": {
      "menu_title": "Hulp & Bronnen",
      "documentation": "Documentatie",
      "video_tutorials": "Video Tutorials",
      "send_feedback": "Feedback Versturen",
      "contact_support": "Contact Opnemen met Support"
    },
    "feedback": {
      "title": "Feedback Versturen",
      "description": "Help ons MoneyLights te verbeteren. Deel je feedback, meld bugs of stel nieuwe functies voor.",
      "type_label": "Feedback Type",
      "type_feedback": "Algemene Feedback",
      "type_bug": "Bug Melden",
      "type_feature": "Functieverzoek",
      "type_feedback_desc": "Deel je gedachten over MoneyLights",
      "type_bug_desc": "Een probleem of fout melden",
      "type_feature_desc": "Een nieuwe functie voorstellen",
      "subject_label": "Onderwerp",
      "subject_placeholder": "Kort beschrijven...",
      "message_label": "Bericht",
      "message_placeholder": "Geef zoveel mogelijk details...",
      "message_bug_placeholder": "Beschrijf de bug:\n\n1. Wat verwachtte je dat er zou gebeuren?\n2. Wat gebeurde er werkelijk?\n3. Stappen om het probleem te reproduceren",
      "message_feature_placeholder": "Beschrijf de functie die je zou willen zien:\n\n1. Welk probleem zal het oplossen?\n2. Hoe stel je je voor dat het werkt?\n3. Wie zal er baat bij hebben?",
      "email_label": "E-mail",
      "email_placeholder": "Je e-mail (optioneel)",
      "email_help": "Zodat we je feedback kunnen opvolgen",
      "priority_label": "Prioriteit",
      "priority_low": "Laag",
      "priority_medium": "Middel",
      "priority_high": "Hoog",
      "priority_critical": "Kritiek",
      "cancel": "Annuleren",
      "submit": "Feedback Versturen",
      "submitting": "Versturen...",
      "success_title": "Feedback Verzonden!",
      "success_description": "Bedankt voor je feedback. We zullen het bekijken en indien nodig contact met je opnemen.",
      "error_title": "Fout bij Versturen",
      "error_description": "We konden je feedback niet versturen. Probeer het opnieuw.",
      "button_label": "Feedback & Ondersteuning",
      "button_short": "Feedback"
    },
    "trial": {
      "banner": {
        "cta": "Kies een plan",
        "dismiss": "Proefperiode-banner verbergen",
        "active": {
          "title": "Proefperiode — nog {{days}} dagen (eindigt {{endDate}})",
          "description": "Volledige toegang tot alle functies."
        },
        "last_day": {
          "title": "De proefperiode eindigt morgen",
          "description": "Kies een plan om MoneyLights zonder onderbreking te blijven gebruiken."
        },
        "expired": {
          "title": "Proefperiode beëindigd",
          "description": "Kies een plan om echte bankgegevens en financiële inzichten te blijven gebruiken."
        }
      },
      "empty_state": {
        "title": "Gegevens gepauzeerd",
        "description": "Je proefperiode is beëindigd. Kies een plan om in dit account echte bankgegevens te blijven zien.",
        "cta": "Kies een plan"
      }
    },
    "profit_pulse": {
      "bucket_revenue": "Omzet",
      "bucket_operations": "Operationele kosten",
      "bucket_profit_vault": "Winst",
      "bucket_taxes": "Belastingreserve",
      "bucket_owner_pay": "Eigenaarssalaris",
      "bucket_reserve": "Reserve",
      "load_error_title": "Pulse kon niet worden geladen",
      "load_error_body": "Controleer je verbinding en probeer het opnieuw.",
      "retry": "Opnieuw proberen"
    }
  },
  "sv": {
    "modes": {
      "operate": "Hantera",
      "analyze": "Analysera",
      "plan": "Planera"
    },
    "navigation": {
      "assistant": "Prata med dina pengar",
      "analytics": "Analys",
      "cashflow": "Kassaflöde",
      "transactions": "Transaktioner",
      "budgets": "Budgetar",
      "calendar": "Kalender",
      "clients": "Kunder",
      "projects": "Projekt",
      "vendors": "Leverantörer",
      "people": "Personer",
      "reports": "Rapporter",
      "categories": "Kategorier",
      "team_members": "Teammedlemmar",
      "bank_connections": "Bankförbindelser",
      "billing": "Fakturering",
      "settings": "Inställningar",
      "profile": "Profil",
      "notifications": "Meddelanden",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Sök",
      "search_placeholder": "Sök...",
      "profile": "Profil",
      "notifications": "Meddelanden",
      "settings": "Inställningar",
      "logout": "Logga ut",
      "language": "Språk",
      "section_organizations": "Organisationer",
      "section_my_account": "Mitt konto",
      "section_organization": "Organisation",
      "mark_all_read": "Markera alla som lästa",
      "view_all_notifications": "Visa alla meddelanden",
      "ask_money": "Fråga dina pengar"
    },
    "sidebar": {
      "collapse": "Fäll ihop menyn",
      "expand": "Fäll ut menyn"
    },
    "tenant_selector": {
      "create_new": "Skapa ny organisation"
    },
    "help": {
      "menu_title": "Hjälp & Resurser",
      "documentation": "Dokumentation",
      "video_tutorials": "Videohandledningar",
      "send_feedback": "Skicka Feedback",
      "contact_support": "Kontakta Support"
    },
    "feedback": {
      "title": "Skicka Feedback",
      "description": "Hjälp oss att förbättra MoneyLights. Dela din feedback, rapportera buggar eller föreslå nya funktioner.",
      "type_label": "Feedback-typ",
      "type_feedback": "Allmän Feedback",
      "type_bug": "Rapportera Bugg",
      "type_feature": "Funktionsförfrågan",
      "type_feedback_desc": "Dela dina tankar om MoneyLights",
      "type_bug_desc": "Rapportera ett problem eller fel",
      "type_feature_desc": "Föreslå en ny funktion",
      "subject_label": "Ämne",
      "subject_placeholder": "Beskriv kortfattat...",
      "message_label": "Meddelande",
      "message_placeholder": "Vänligen ge så mycket detaljer som möjligt...",
      "message_bug_placeholder": "Beskriv buggen:\n\n1. Vad förväntade du dig skulle hända?\n2. Vad hände egentligen?\n3. Steg för att återskapa problemet",
      "message_feature_placeholder": "Beskriv funktionen du skulle vilja se:\n\n1. Vilket problem kommer det att lösa?\n2. Hur föreställer du dig att det fungerar?\n3. Vem kommer att dra nytta av det?",
      "email_label": "E-post",
      "email_placeholder": "Din e-post (valfritt)",
      "email_help": "Så att vi kan följa upp din feedback",
      "priority_label": "Prioritet",
      "priority_low": "Låg",
      "priority_medium": "Medel",
      "priority_high": "Hög",
      "priority_critical": "Kritisk",
      "cancel": "Avbryt",
      "submit": "Skicka Feedback",
      "submitting": "Skickar...",
      "success_title": "Feedback Skickad!",
      "success_description": "Tack för din feedback. Vi kommer att granska den och kontakta dig vid behov.",
      "error_title": "Fel vid Skickande",
      "error_description": "Vi kunde inte skicka din feedback. Försök igen.",
      "button_label": "Feedback & Support",
      "button_short": "Feedback"
    },
    "trial": {
      "banner": {
        "cta": "Välj en plan",
        "dismiss": "Dölj provperiodsbanner",
        "active": {
          "title": "Provperiod — {{days}} dagar kvar (slutar {{endDate}})",
          "description": "Full åtkomst till alla funktioner."
        },
        "last_day": {
          "title": "Provperioden slutar i morgon",
          "description": "Välj en plan för att fortsätta använda MoneyLights utan avbrott."
        },
        "expired": {
          "title": "Provperioden har avslutats",
          "description": "Välj en plan för att fortsätta använda riktiga bankdata och finansiella insikter."
        }
      },
      "empty_state": {
        "title": "Data pausad",
        "description": "Din provperiod har avslutats. Välj en plan för att fortsätta se riktiga bankdata i detta konto.",
        "cta": "Välj en plan"
      }
    },
    "profit_pulse": {
      "bucket_revenue": "Intäkter",
      "bucket_operations": "Driftskostnader",
      "bucket_profit_vault": "Vinst",
      "bucket_taxes": "Skattereserv",
      "bucket_owner_pay": "Ägarlön",
      "bucket_reserve": "Reserv",
      "load_error_title": "Kunde inte ladda Pulse",
      "load_error_body": "Kontrollera din anslutning och försök igen.",
      "retry": "Försök igen"
    }
  },
  "da": {
    "modes": {
      "operate": "Styre",
      "analyze": "Analysere",
      "plan": "Planl\u00e6gge"
    },
    "navigation": {
      "assistant": "Tal med dine penge",
      "analytics": "Analyse",
      "cashflow": "Pengestrøm",
      "transactions": "Transaktioner",
      "budgets": "Budgetter",
      "calendar": "Kalender",
      "clients": "Klienter",
      "projects": "Projekter",
      "vendors": "Leverandører",
      "people": "Personer",
      "reports": "Rapporter",
      "categories": "Kategorier",
      "team_members": "Teammedlemmer",
      "bank_connections": "Bankforbindelser",
      "billing": "Fakturering",
      "settings": "Indstillinger",
      "profile": "Profil",
      "notifications": "Meddelelser",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Søg",
      "search_placeholder": "Søg...",
      "profile": "Profil",
      "notifications": "Meddelelser",
      "settings": "Indstillinger",
      "logout": "Log ud",
      "language": "Sprog",
      "section_organizations": "Organisationer",
      "section_my_account": "Min konto",
      "section_organization": "Organisation",
      "mark_all_read": "Marker alle som læst",
      "view_all_notifications": "Se alle meddelelser",
      "ask_money": "Spørg dine penge"
    },
    "sidebar": {
      "collapse": "Fold menuen sammen",
      "expand": "Fold menuen ud"
    },
    "tenant_selector": {
      "create_new": "Opret ny organisation"
    },
    "help": {
      "menu_title": "Hjælp & Ressourcer",
      "documentation": "Dokumentation",
      "video_tutorials": "Videovejledninger",
      "send_feedback": "Send Feedback",
      "contact_support": "Kontakt Support"
    },
    "feedback": {
      "title": "Send Feedback",
      "description": "Hjælp os med at forbedre MoneyLights. Del din feedback, rapporter fejl eller foreslå nye funktioner.",
      "type_label": "Feedback-type",
      "type_feedback": "Generel Feedback",
      "type_bug": "Rapporter Fejl",
      "type_feature": "Funktionsanmodning",
      "type_feedback_desc": "Del dine tanker om MoneyLights",
      "type_bug_desc": "Rapporter et problem eller en fejl",
      "type_feature_desc": "Foreslå en ny funktion",
      "subject_label": "Emne",
      "subject_placeholder": "Beskriv kort...",
      "message_label": "Besked",
      "message_placeholder": "Angiv så mange detaljer som muligt...",
      "message_bug_placeholder": "Beskriv fejlen:\n\n1. Hvad forventede du skulle ske?\n2. Hvad skete der faktisk?\n3. Trin til at genskabe problemet",
      "message_feature_placeholder": "Beskriv funktionen, du gerne vil se:\n\n1. Hvilket problem vil det løse?\n2. Hvordan forestiller du dig, at det fungerer?\n3. Hvem vil have gavn af det?",
      "email_label": "E-mail",
      "email_placeholder": "Din e-mail (valgfri)",
      "email_help": "Så vi kan følge op på din feedback",
      "priority_label": "Prioritet",
      "priority_low": "Lav",
      "priority_medium": "Mellem",
      "priority_high": "Høj",
      "priority_critical": "Kritisk",
      "cancel": "Annuller",
      "submit": "Send Feedback",
      "submitting": "Sender...",
      "success_title": "Feedback Sendt!",
      "success_description": "Tak for din feedback. Vi vil gennemgå den og kontakte dig, hvis det er nødvendigt.",
      "error_title": "Fejl ved Afsendelse",
      "error_description": "Vi kunne ikke sende din feedback. Prøv igen.",
      "button_label": "Feedback & Support",
      "button_short": "Feedback"
    },
    "trial": {
      "banner": {
        "cta": "Vælg en plan",
        "dismiss": "Skjul prøveperiodebanner",
        "active": {
          "title": "Prøveperiode — {{days}} dage tilbage (slutter {{endDate}})",
          "description": "Fuld adgang til alle funktioner."
        },
        "last_day": {
          "title": "Prøveperioden slutter i morgen",
          "description": "Vælg en plan for at fortsætte med at bruge MoneyLights uden afbrydelse."
        },
        "expired": {
          "title": "Prøveperioden er slut",
          "description": "Vælg en plan for at fortsætte med at bruge rigtige bankdata og finansielle indsigter."
        }
      },
      "empty_state": {
        "title": "Data sat på pause",
        "description": "Din prøveperiode er slut. Vælg en plan for at fortsætte med at se rigtige bankdata på denne konto.",
        "cta": "Vælg en plan"
      }
    },
    "profit_pulse": {
      "bucket_revenue": "Indtægter",
      "bucket_operations": "Driftsomkostninger",
      "bucket_profit_vault": "Overskud",
      "bucket_taxes": "Skattereserve",
      "bucket_owner_pay": "Ejerløn",
      "bucket_reserve": "Reserve",
      "load_error_title": "Kunne ikke indlæse Pulse",
      "load_error_body": "Tjek din forbindelse og prøv igen.",
      "retry": "Prøv igen"
    }
  },
  "fi": {
    "modes": {
      "operate": "Toimia",
      "analyze": "Analysoida",
      "plan": "Suunnitella"
    },
    "navigation": {
      "assistant": "Keskustele rahojesi kanssa",
      "analytics": "Analytiikka",
      "cashflow": "Kassavirta",
      "transactions": "Tapahtumat",
      "budgets": "Budjetit",
      "calendar": "Kalenteri",
      "clients": "Asiakkaat",
      "projects": "Projektit",
      "vendors": "Toimittajat",
      "people": "Henkilöt",
      "reports": "Raportit",
      "categories": "Kategoriat",
      "team_members": "Tiimin Jäsenet",
      "bank_connections": "Pankkiyhteydet",
      "billing": "Laskutus",
      "settings": "Asetukset",
      "profile": "Profiili",
      "notifications": "Ilmoitukset",
      "ai_labs": "AI Labs"
    },
    "topbar": {
      "search": "Hae",
      "search_placeholder": "Hae...",
      "profile": "Profiili",
      "notifications": "Ilmoitukset",
      "settings": "Asetukset",
      "logout": "Kirjaudu ulos",
      "language": "Kieli",
      "section_organizations": "Organisaatiot",
      "section_my_account": "Oma tili",
      "section_organization": "Organisaatio",
      "mark_all_read": "Merkitse kaikki luetuiksi",
      "view_all_notifications": "Näytä kaikki ilmoitukset",
      "ask_money": "Kysy rahoiltasi"
    },
    "sidebar": {
      "collapse": "Supista valikko",
      "expand": "Laajenna valikko"
    },
    "tenant_selector": {
      "create_new": "Luo uusi organisaatio"
    },
    "help": {
      "menu_title": "Apu & Resurssit",
      "documentation": "Dokumentaatio",
      "video_tutorials": "Video-oppaat",
      "send_feedback": "Lähetä Palautetta",
      "contact_support": "Ota Yhteyttä Tukeen"
    },
    "feedback": {
      "title": "Lähetä Palautetta",
      "description": "Auta meitä parantamaan MoneyLightsia. Jaa palautteesi, raportoi virheitä tai ehdota uusia ominaisuuksia.",
      "type_label": "Palautteen Tyyppi",
      "type_feedback": "Yleinen Palaute",
      "type_bug": "Raportoi Virhe",
      "type_feature": "Ominaisuuspyyntö",
      "type_feedback_desc": "Jaa ajatuksesi MoneyLightsista",
      "type_bug_desc": "Raportoi ongelma tai virhe",
      "type_feature_desc": "Ehdota uutta ominaisuutta",
      "subject_label": "Aihe",
      "subject_placeholder": "Kuvaile lyhyesti...",
      "message_label": "Viesti",
      "message_placeholder": "Anna mahdollisimman paljon yksityiskohtia...",
      "message_bug_placeholder": "Kuvaile virhe:\n\n1. Mitä odotit tapahtuvan?\n2. Mitä todella tapahtui?\n3. Vaiheet ongelman toistamiseksi",
      "message_feature_placeholder": "Kuvaile ominaisuus, jonka haluaisit nähdä:\n\n1. Minkä ongelman se ratkaisee?\n2. Miten kuvittelet sen toimivan?\n3. Kuka siitä hyötyy?",
      "email_label": "Sähköposti",
      "email_placeholder": "Sähköpostisi (valinnainen)",
      "email_help": "Jotta voimme seurata palautettasi",
      "priority_label": "Prioriteetti",
      "priority_low": "Matala",
      "priority_medium": "Keskitaso",
      "priority_high": "Korkea",
      "priority_critical": "Kriittinen",
      "cancel": "Peruuta",
      "submit": "Lähetä Palaute",
      "submitting": "Lähetetään...",
      "success_title": "Palaute Lähetetty!",
      "success_description": "Kiitos palautteestasi. Tarkistamme sen ja otamme sinuun yhteyttä tarvittaessa.",
      "error_title": "Lähetysvirhe",
      "error_description": "Emme voineet lähettää palautettasi. Yritä uudelleen.",
      "button_label": "Palaute & Tuki",
      "button_short": "Palaute"
    },
    "trial": {
      "banner": {
        "cta": "Valitse suunnitelma",
        "dismiss": "Piilota kokeilubanneri",
        "active": {
          "title": "Kokeilu — {{days}} päivää jäljellä (päättyy {{endDate}})",
          "description": "Täysi pääsy kaikkiin ominaisuuksiin."
        },
        "last_day": {
          "title": "Kokeilu päättyy huomenna",
          "description": "Valitse suunnitelma jatkaaksesi MoneyLightsin käyttöä ilman keskeytyksiä."
        },
        "expired": {
          "title": "Kokeilu on päättynyt",
          "description": "Valitse suunnitelma jatkaaksesi oikeiden pankkitietojen ja talousnäkemysten käyttöä."
        }
      },
      "empty_state": {
        "title": "Tiedot keskeytetty",
        "description": "Kokeilusi on päättynyt. Valitse suunnitelma jatkaaksesi oikeiden pankkitietojen katselua tällä tilillä.",
        "cta": "Valitse suunnitelma"
      }
    },
    "profit_pulse": {
      "bucket_revenue": "Tulot",
      "bucket_operations": "Toimintakulut",
      "bucket_profit_vault": "Voitto",
      "bucket_taxes": "Verovaraus",
      "bucket_owner_pay": "Omistajan palkka",
      "bucket_reserve": "Varanto",
      "load_error_title": "Pulsen lataaminen epäonnistui",
      "load_error_body": "Tarkista yhteys ja yritä uudelleen.",
      "retry": "Yritä uudelleen"
    }
  }
};
